var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 user-modal-register-payment-success-view px-2" },
    [
      _c("div", { staticClass: "mb-5 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200" }, [
          _vm._v(_vm._s(_vm.titleText)),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mb-0 font-size-125" }, [
          _vm._v(_vm._s(_vm._f("trans")("You are awesome!"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-5 d-flex justify-content-center" }, [
        _c(
          "div",
          {
            staticClass: "circle-loader",
            class: { "load-complete": _vm.finishLoader },
          },
          [
            _c("div", {
              staticClass: "checkmark draw",
              class: { "d-block": _vm.finishLoader },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-5 text-center" }, [
        _vm.isTrial
          ? _c("p", { staticClass: "mb-0 font-size-125" }, [
              _vm._v(_vm._s(_vm._f("trans")("Your free trial started."))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isTrial && _vm.trialMainText
          ? _c("p", { staticClass: "mb-0 font-size-125" }, [
              _vm._v(_vm._s(_vm.trialMainText)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "mb-5 font-size-125" }, [
          _vm._v(
            _vm._s(
              _vm._f("trans")(
                "If you have any questions feel free to get in touch."
              )
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
        attrs: {
          "data-user-modal-button-submit": "",
          icon: "fa fa-arrow-right lh-1",
          text: _vm._f("trans")("Continue"),
          "is-state-loading": _vm.isSubmitting,
          "show-icon-after-text": true,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.doContinue.apply(null, arguments)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }